export default "__VITE_ASSET__Bzv1hocC__"